module.exports = __webpack_public_path__ + "img/9d.95ef3608.png";